import axiosHttp from 'axios';

/** Axios HTTP client exposed as a JsonUI `$action` handler (`$action: "axios"`). */
const axios = (params) => axiosHttp(params);

export { axios };
//# sourceMappingURL=index.js.map
